let instance = null
class OrderRepository {
    static getInstance(app) {
        if (!instance) {
            instance = new OrderRepository(app)
        }
        return instance
    }
    constructor(app) {
        this.app = app
    }
    cancelOrder = (order, callback) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "/orders/" + order.id,
                type: "patch",
                data: {
                    update_order_status_only: 1,
                    order_status: "cancelled",
                },
                success: function (response) {
                    callback && callback()
                    resolve()
                }
            })
        })
    }
}

export default OrderRepository